<script setup>
import RatingSquareScore from '@/Pages/DomainScore/Partials/RatingSquareScore.vue';
import RiskLabel from '@/Pages/DomainScore/Partials/RiskLabel.vue';
import { inject } from 'vue';
import TlsCard from '@/Pages/DomainScore/Partials/DetailedReport/Privacy/TlsCard.vue';
import MtaStsCard from '@/Pages/DomainScore/Partials/DetailedReport/Privacy/MtaStsCard.vue';
import Help from '@/Components/Help.vue';
import ACTION_TYPES, {
  getActionTypeFromScore
} from '@/Common/Enum/ActionType.js';

const result = inject('score');
const actionType = getActionTypeFromScore(result.privacy.score);
</script>

<template>
  <div class="flex items-start gap-3">
    <div class="flex flex-col items-center">
      <RatingSquareScore :score="result.privacy.score" />
      <RiskLabel
        :score="result.privacy.score"
        class="mt-1 text-sm text-nowrap"
      />
    </div>
    <div class="flex flex-col gap-2">
      <h5 class="flex items-center gap-2 text-lg font-bold text-white">
        {{
          $t(
            'domain_score.partials.detailed_report.privacy.privacy_detail_card.privacy_rating'
          )
        }}
        <Help
          :text="
            $t(
              'domain_score.partials.detailed_report.privacy.privacy_detail_card.privacy_rating_help'
            )
          "
        />
      </h5>
      <p v-if="actionType === ACTION_TYPES.NO_ACTION">
        {{
          $t(
            'domain_score.partials.detailed_report.privacy.privacy_detail_card.your_emails_are_at'
          )
        }}
      </p>
      <p v-else-if="actionType === ACTION_TYPES.ACTION_RECOMMENDED">
        {{
          $t(
            'domain_score.partials.detailed_report.privacy.privacy_detail_card.you_need_to_tighten'
          )
        }}
      </p>
      <p v-else>
        {{
          $t(
            'domain_score.partials.detailed_report.privacy.privacy_detail_card.action_required'
          )
        }}
      </p>
    </div>
  </div>
  <div class="mt-4 flex flex-col gap-2 md:gap-4">
    <TlsCard />
    <MtaStsCard />
  </div>
</template>
